import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import login from "../Images/login.jpg";
import InputField from "../Components/InputField";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import axios from "../shared";

const LoginPage = () => {
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const { location, state } = useLocation();
  const [alert, setAlert] = useState(state ? state : null);
  const [resend, setResend] = useState(false);
  const [resendEmail, setResendEmail] = useState("");

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const inputs = [
    {
      id: 1,
      name: "email",
      type: "email",
      placeholder: "Enter email",
      errorMessage: "Enter a valid email address!",
      label: "Email",
      required: true,
    },
    {
      id: 2,
      name: "password",
      type: "password",
      placeholder: "Enter password",
      errorMessage: "Enter password!",
      label: "Password",
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("auth/login/", JSON.stringify(values));
      const accessToken = response?.data?.data["access"];

      const user = response?.data.data;
      setAuth({ ...values, accessToken, user });

      if (user?.roles === 0 || user?.roles === 1) {
        //navigates doctor to edit profile on first login
        if (user?.last_login === null && user?.roles === 1) {
          navigate(`/edit/doctor/${user?.id}`, {
            state: {
              message: "Update your profile.",
              type: "info",
            },
          });
        } else {
          navigate(location?.state?.from?.pathname || "/list/appointment", {
            replace: true,
          });
        }
      } else if (user?.roles === 2) {
        //navigates patient to edit profile on first login
        if (user?.last_login === null) {
          navigate("/edit/profile", {
            state: {
              message: "Update your profile.",
              type: "info",
            },
          });
        } else {
          navigate(location?.state?.from?.pathname || "/doctor", {
            replace: true,
          });
        }
      }
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Invalid Credentials.", "warning");
      } else if (err.response?.status === 401) {
        showAlert("Account is not active.", "warning");
        setResend(true);
        setResendEmail(values.email);
      } else {
        showAlert("Login Failed", "warning");
      }
    }
  };

  const onResend = async () => {
    try {
      const data = {
        email: resendEmail,
      };
      await axios.post("auth/resend/activation/", data);

      showAlert(
        "An activation link is sent to your registered mail.",
        "success"
      );
      setResend(false);
      setResendEmail("");
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 404) {
        showAlert("Email not found.", "warning");
      } else {
        showAlert("Failed. Try Again Later.", "warning");
      }
    }
  };

  return (
    <div>
      <AlertField alert={alert} />
      <div className="container my-md-5">
        <div className="row row-cols-md-2 row-cols-1">
          <div className="col-md-6" style={{ height: 30 + "rem" }}>
            <div className="h-100 text-bg-dark rounded-3">
              <img src={login} alt="pic" className="w-100 h-100" />
            </div>
          </div>
          <div className="col-md-6" style={{ height: 30 + "rem" }}>
            <div className="h-100 p-5 bg-light border rounded-3">
              <h1 className="text-center">Log In</h1>

              <form onSubmit={handleSubmit}>
                {inputs.map((input) => (
                  <InputField
                    key={input.id}
                    {...input}
                    value={values[input.name]}
                    onChange={onChange}
                  />
                ))}
                <h6 className="mt-4">
                  <a
                    href="#"
                    onClick={onResend}
                    className={`btn m-0 p-0 text-danger text-decoration-underline ${
                      !resend && "d-none"
                    }`}
                  >
                    Click to resend activation link.
                  </a>
                  <a className="float-end" href="/reset/password">
                    Forgot your password?
                  </a>
                </h6>
                <br />
                <div className="text-center">
                  <button className="btn btn-primary m-2 py-1 px-5">
                    Log In
                  </button>
                </div>
                <div className="d-flex justify-content-end mt-2">
                  <p className="mx-1">Don't have an account?</p>
                  <a href="/register">Register</a>
                  <br />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
